module.exports = __webpack_public_path__ + "img/pc_self_old.7dba3ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterAd/image/pc_self_old.jpg
// module id = pmQ5
// module chunks = 0